export default __webpack_public_path__ + "static/media/useEffect.c5955dcd.md";